var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { CustomDatePickerComponent } from '../custom-date-picker/custom-date-picker.component';
export var SHORT_DATE_FORMATS = {
    parse: {
        dateInput: 'YYYY MMMM',
    },
    display: {
        dateInput: 'YYYY MMMM',
        monthYearLabel: 'MMM YYYY',
        dateA11yLabel: 'LL',
        monthYearA11yLabel: 'MMMM YYYY',
    },
};
var ShortDatePickerComponent = /** @class */ (function (_super) {
    __extends(ShortDatePickerComponent, _super);
    function ShortDatePickerComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.format = SHORT_DATE_FORMATS.parse.dateInput;
        return _this;
    }
    ShortDatePickerComponent.prototype.chosenMonthHandler = function (dateMoment, datepicker) {
        this.dateChanged(dateMoment.toDate());
        datepicker.close();
    };
    return ShortDatePickerComponent;
}(CustomDatePickerComponent));
export { ShortDatePickerComponent };
